// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { batchClearanceDefinitionId } from './BatchClearanceDefinition';
import { testTemplateId } from './TestTemplate';
import { z } from 'zod';
export const batchClearanceDefinitionItemId = (z.number());
export const batchClearanceDefinitionItem = z.object({
    id: batchClearanceDefinitionItemId,
    batch_clearance_definition_id: batchClearanceDefinitionId,
    test_template_id: testTemplateId,
    is_mandatory: z.boolean(),
    execution_phase: z.string().nullable(),
    order_of_execution: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const batchClearanceDefinitionItemInitializer = z.object({
    id: batchClearanceDefinitionItemId.optional(),
    batch_clearance_definition_id: batchClearanceDefinitionId,
    test_template_id: testTemplateId,
    is_mandatory: z.boolean().optional(),
    execution_phase: z.string().optional().nullable(),
    order_of_execution: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const batchClearanceDefinitionItemMutator = z.object({
    id: batchClearanceDefinitionItemId.optional(),
    batch_clearance_definition_id: batchClearanceDefinitionId.optional(),
    test_template_id: testTemplateId.optional(),
    is_mandatory: z.boolean().optional(),
    execution_phase: z.string().optional().nullable(),
    order_of_execution: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=BatchClearanceDefinitionItem.js.map